module.exports = __webpack_public_path__ + "static/img/dash-title-heat.0b7a21a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dash-title-heat.png
// module id = xX7p
// module chunks = 1